import React, { useState } from 'react'
import { type ConnectedProps, connect } from 'react-redux'
import { exportGraphDataService, type ExportGraphRequest } from '../services/exportGraphDataService'
import ExportGraph from '../../../assets/downloadGraph.png'
import CustomToast from './ToastComponent'
import { CircularProgress, Tooltip } from '@mui/material'

const ExportGraphData = (props: AllProps): JSX.Element => {
  const disable = props?.requestParameter?.assets?.length === 0 && (props?.requestParameter?.devices?.length === 0 || props?.requestParameter?.devices?.filter((d: any) => d.cimCodeIds?.length > 0 || d.kpidefinitionIds?.length > 0)?.length === 0)
  const [downloadInProgress, setDownloadInProgress] = useState<boolean>(false)
  const handleExportclick = (): void => {
    if (!disable) {
      setDownloadInProgress(true)
      props.exportGraphData(props?.startDateTime, props?.endDateTime, props?.type, props?.requestParameter, () => {
        setDownloadInProgress(false)
      }).finally(() => {
        // Success
      })
    } else {
      CustomToast({
        type: 'error',
        heading: 'Failed',
        message: 'No Parameters Selected'
      })
    }
  }

  return (
    <>
        <span>

        </span>
        {!downloadInProgress
          ? (
          <img id={'exportButton'} src={ExportGraph} onClick={handleExportclick} style={{ cursor: 'pointer', marginTop: '7px', width: '42px', height: '43px', marginRight: '5px' }}>
          </img>
            )
          : (
          <>
          <span style={{
            cursor: 'pointer',
            marginTop: '8px',
            width: '38px',
            height: '39px',
            background: '#454343',
            display: 'inline-flex',
            borderRadius: '3px',
            justifyContent: 'center',
            verticalAlign: 'top',
            padding: '10px',
            marginRight: '8px',
            marginBottom: '8px'
          }}>
              <Tooltip title={'Downloading...'} arrow>
                  <CircularProgress size={18} color={'primary'} />
              </Tooltip>
          </span>
        </>)}

    </>
  )
}

interface DispatchToProps {
  exportGraphData: (startDateTime: string,
    endDateTime: string,
    type: string,
    requestParameter: ExportGraphRequest,
    callback: any) => Promise<void>
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  exportGraphData: async (startDateTime: string,
    endDateTime: string,
    type: string,
    requestParameter: ExportGraphRequest,
    callback: any): Promise<void> => {
    await exportGraphDataService(startDateTime, endDateTime, type, requestParameter, () => {
      callback()
      CustomToast({
        type: 'success',
        heading: 'Success',
        message: 'File Downloaded'
      })
    }, () => {
      callback()
      CustomToast({
        type: 'error',
        heading: 'Failed',
        message: 'Download failed'
      })
    })
  }
})

const connector = connect(mapDispatchToProps)

interface IExportGraphProps {
  startDateTime: string
  endDateTime: string
  type: string
  requestParameter: ExportGraphRequest
}

type PropsFromRedux = ConnectedProps<typeof connector>
type AllProps = PropsFromRedux & IExportGraphProps

export const MemorizedExport = React.memo(connector(ExportGraphData))
